<template>
  <a-form
      ref="userFormRef"
      :model="formData"
      name="basic"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      class="settings-form"
  >
    <a-form-item v-if="formData.status !== 1" label="状态" name="status">
      <a-tag v-if="formData.status === -2" color="error">认证中</a-tag>
      <a-tag v-if="formData.status === -1" color="error">认证未通过</a-tag>
      <a-tag v-if="formData.status === 0" color="warning">未认证</a-tag>
      <a-tag v-if="formData.status === 1" color="error">已认证</a-tag>
    </a-form-item>
    <a-form-item v-if="formData.status === -1 && formData.reviewMsg" label="意见" name="reviewMsg">
      {{ formData.reviewMsg }}
    </a-form-item>
    
    <a-form-item label="企业名称" name="name">
      <a-input v-if="formData.status !== 1" v-model:value="formData.name" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.name" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="法人姓名" name="corporationName">
      <a-input v-if="formData.status !== 1" v-model:value="formData.corporationName" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.corporationName" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="统一信用代码" name="unifyCode">
      <a-input v-if="formData.status !== 1" v-model:value="formData.unifyCode" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.unifyCode" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="联系人姓名" name="linkName">
      <a-input v-if="formData.status !== 1" v-model:value="formData.linkName" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.linkName" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="联系人电话" name="linkPhone">
      <a-input v-if="formData.status !== 1" v-model:value="formData.linkPhone" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.linkPhone" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="联系地址" name="address">
      <a-input v-if="formData.status !== 1" v-model:value="formData.address" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.address" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="邮箱" name="email">
      <a-input v-if="formData.status !== 1" v-model:value="formData.email" placeholder="请输入" />
      <a-input v-else readonly v-model:value="formData.email" placeholder="请输入" />
    </a-form-item>
    
    <a-form-item label="申请主体类型">
      <a-radio-group v-if="formData.status !== 1" v-model:value="formData.category">
        <a-radio
            v-for="(item, index) in typeList"
            :key="item.id"
            :value="item.dataCode + ''"
            @change="radioChange"
        >
          {{ item.dataValue }}
          <div v-if="item.dataValue === '其它科技型企业' && flag">
            <input class="old_inp" type="text" v-model="userInput" />
          </div>
        </a-radio>
      </a-radio-group>
      <!-- 添加禁用状态的显示逻辑 -->
      <div v-else>
        <!-- 显示当前选中的申请主体类型 -->
        <span v-if="formData.category && formData.category !== 'other'">
              {{ getTypeTextByCode(formData.category) }}
            </span>
        <!-- 特殊处理其它科技型企业 -->
        <span v-else-if="formData.category && formData.category.includes('other')">
              {{ getOtherTypeText(formData.category) }}
            </span>
        <span v-else>未选择</span>
      </div>
    </a-form-item>
    
    <a-form-item label="资质附件" name="licenseAttachmentArr" tooltip="企业需上传公司营业职照，高校/研究所需上传单位证明">
      <images-uploader
          v-if="formData.status !== 1"
          v-model:image-urls="formData.licenseAttachmentArr"
          :path-name="'license'"
          :max-count="2"
          :box-width="180"
          :box-height="120"
          @upload-success="handleUploadSuccess"
          @delete="handleDelete"
      />
      <images-uploader
          v-else
          v-model:image-urls="formData.licenseAttachmentArr"
          :path-name="'license'"
          :only-preview="true"
          :max-count="2"
          :box-width="180"
          :box-height="120"
          @upload-success="handleUploadSuccess"
          @delete="handleDelete"
      />
    </a-form-item>
    
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button v-if="formData.status === -1 || formData.status === 0"  type="primary" @click="handleSave">确定</a-button>
    </a-form-item>
  </a-form>
</template>

<script setup>
import {ref, reactive, defineProps, defineEmits, watch, onMounted, onActivated} from "vue";
import { message } from "ant-design-vue";
import { useRouter } from 'vue-router'

import { selectByCurrentUser, authentication} from '@/api/enterprise';
import imagesUploader from '@/components/imagesUploader/index.vue'
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
const store = useUserStore();
const router = useRouter();
const appStore = useAppStore();
const dataType = "companyType";

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update:userInfo']);

const userFormRef = ref();
const formData = reactive({
  status: 0,
});
const typeList = ref([]); // 申请主体类型列表
const flag = ref(false); // 其他科技型企业标志
const userInput = ref(''); // 其他科技型企业输入

// 监听系统字典变化，获取申请主体类型列表
watch(
    () => appStore.SysDictVOList,
    (val) => {
      console.log(val);
      if (val.length > 0) {
        const index = val.findIndex((item) => item.dataType === dataType);
        if (index !== -1) {
          typeList.value = val[index].children;
          console.log(typeList.value);
        }
      }
    },
    {
      deep: true,
      immediate: true,
    }
);

const rules = ref({
  name: [{ required: true, message: "企业名称不能为空", trigger: "blur" }],
  corporationName: [{ required: true, message: "法人姓名不能为空", trigger: "blur" }],
  unifyCode: [{ required: true, message: "统一信用代码不能为空", trigger: "blur" }],
  linkName: [{ required: true, message: "联系人姓名不能为空", trigger: "blur" }],
  linkPhone: [{ required: true, message: "联系人电话不能为空", trigger: "blur" }, { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "blur" }],
  address: [{ required: true, message: "联系地址不能为空", trigger: "blur" }],
});

// 单选框变化事件
const radioChange = (e) => {
  if (e.target.value === "other") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};

// 根据代码获取类型文本
const getTypeTextByCode = (code) => {
  const type = typeList.value.find(item => item.dataCode === code);
  return type ? type.dataValue : code;
};

// 获取其他类型文本
const getOtherTypeText = (category) => {
  if (category.includes('other')) {
    return category.replace('other_', '') || '其它科技型企业';
  }
  return '其它科技型企业';
};

// 上传成功处理
const handleUploadSuccess = (url, urls) => {
  console.log('上传成功', url);
  console.log('当前所有图片', urls);
};

// 获取数据
const selectEnterpriseDataByCurrentUser = () => {
  selectByCurrentUser().then((res) => {
    console.log(res);
    if (res.code === 200) {
      if (res.data) {
        Object.assign(formData, res.data);
        if (
            res.data.category.indexOf("other_") != -1 ||
            res.data.category.indexOf("other") != -1
        ) {
          flag.value = true;
          let arr = res.data.category.split("_");
          console.log(arr);
          formData.category = arr[0];
          userInput.value = arr[1];
        }
      }
    }
  });
};

// 删除处理
const handleDelete = (index) => {
  console.log('删除图片索引', index);
};

// 保存基本信息
const handleSave = () => {
  userFormRef.value.validate().then(() => {
    // 处理其他科技型企业
    if (formData.category === 'other' && userInput.value) {
      formData.category = 'other_' + userInput.value;
    }
    
    // 这里调用API保存基本信息
    authentication(formData).then(res => {
      if (res.code === 200 && res.data){
        message.success('企业认证信息提交成功');
        // 触发事件，更新父组件中的用户信息
        emit('update:userInfo', formData);
        selectEnterpriseDataByCurrentUser();
      }else {
        console.error(res.msg);
        message.success('企业认证信息提交失败');
      }
    });
  }).catch(error => {
    console.log('表单验证失败:', error);
  });
};

onMounted(() => {
  selectEnterpriseDataByCurrentUser();
});

// 当组件被激活时（例如从缓存中恢复）重新加载数据
onActivated(() => {
  selectEnterpriseDataByCurrentUser();
});
</script>

<style lang="less" scoped>
.settings-form {
  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item-label > label {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1d2129 !important;
  }

  .ant-radio-wrapper {
    margin-right: 16px;
    width: 30%; /* 每行最多显示三个选项 */
    margin-bottom: 10px;
  }

  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .ant-input,
  .ant-input-password,
  .ant-select-selector {
    width: 50% !important;
  }
}
</style>